<script setup>
import { computed } from 'vue';

const props = defineProps({
  src: { type: String, default: '' },
  name: { type: String, default: '' },
  size: { type: String, default: 'md' },
  // `contrast` sits on a primary-coloured surface (the header), where the default tint would vanish.
  tone: { type: String, default: 'default' },
});

const initials = computed(() =>
  props.name
    .split(/\s+/)
    .filter(word => /^\p{L}/u.test(word))
    .slice(0, 2)
    .map(part => part[0].toUpperCase())
    .join('')
);

const sizeClass = computed(
  () =>
    ({
      xs: 'h-7 w-7 text-[11px]',
      sm: 'h-9 w-9 text-xs',
      md: 'h-10 w-10 text-sm',
      lg: 'h-16 w-16 text-xl',
    })[props.size]
);
</script>

<template>
  <span
    class="inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full font-semibold"
    :class="[
      sizeClass,
      tone === 'contrast'
        ? 'bg-on-primary/15 text-on-primary'
        : 'bg-primary/10 text-primary',
    ]"
  >
    <img v-if="src" :src="src" alt="" class="h-full w-full object-cover" />
    <span v-else>{{ initials }}</span>
  </span>
</template>
